/** @format */

export const prodEnvironment = {};
